document.addEventListener("click", function (event) {
  const trigger = event.target.closest('[data-checkin-url]:not([data-checkin-url=""])');
  if (!trigger) return;

  const url = trigger.getAttribute("data-checkin-url");

  if (!url) return;

  event.preventDefault();

  const modalEl = document.getElementById("checkinModal");
  const checkinButton = document.getElementById("checkinButton");

  if (!modalEl || !checkinButton) {
    const win = window.open(url, "_blank");
    if (win) win.opener = null;
    return;
  }

  checkinButton.setAttribute("href", url);

  if (typeof modalEl.open === "function") {
    console.log("Modal element is a function");
    modalEl.open(trigger);
  } else {
    console.log("Modal element is not a function");
  }
});
